import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  FormGroup,
  Row,
  InputGroup,
  InputGroupAddon,
  Input,
} from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import { Field } from 'redux-form';
import QRCode from 'qrcode';
import Loader from '../../../common/Loader';
import LogoCiva from '../../../../resources/images/logo-civa.png';

const OpenpayLinkModal = ({ openpayResponse, isLoading }) => {
  const [qrCode, setQrCode] = useState(null);

  useEffect(() => {
    const generateQrCode = async () => {
      if (openpayResponse && openpayResponse.checkoutLink) {
        try {
          const qrString = await QRCode.toDataURL(
            openpayResponse.checkoutLink,
            {
              errorCorrectionLevel: 'H',
              type: 'image/jpeg',
              scale: 4,
            },
          );
          setQrCode(qrString);
        } catch (error) {
          console.error('Error generating QR Code:', error);
        }
      }
    };
    generateQrCode();
  }, [openpayResponse]);

  const handleCopyToClipboard = () => {
    if (openpayResponse && openpayResponse.checkoutLink) {
      navigator.clipboard.writeText(openpayResponse.checkoutLink).then(() => {
        toastr.success('Enlace copiado al portapapeles');
      });
    }
  };

  return (
    <div>
      <Row className="text-center mb-4">
        <Col>
          <img src={LogoCiva} alt="Logo Civa" width={200} />
        </Col>
      </Row>
      {isLoading && <Loader />}
      {openpayResponse && (
        <div>
          <FormGroup>
            <InputGroup>
              <Field
                name="checkoutLink"
                component={({ input }) => (
                  <Input
                    {...input}
                    type="text"
                    placeholder="Enlace de Checkout"
                    value={openpayResponse.checkoutLink}
                    disabled
                  />
                )}
              />
              <InputGroupAddon addonType="append">
                <Button
                  type="button"
                  color="secondary"
                  onClick={handleCopyToClipboard}
                >
                  <i className="fa fa-clipboard" aria-hidden="true" /> Copiar
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
          {qrCode && (
            <Row className="text-center mt-4">
              <Col>
                <img src={qrCode} alt="QR Code" className="img-fluid" />
              </Col>
            </Row>
          )}
        </div>
      )}
    </div>
  );
};

OpenpayLinkModal.propTypes = {
  openpayResponse: PropTypes.shape({
    checkoutLink: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
};

OpenpayLinkModal.defaultProps = {
  isLoading: true,
  openpayResponse: null,
};

export default OpenpayLinkModal;
